import { FC } from 'react'
import SelectTariffValue, {
  getTariffValueMin,
} from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/components/SelectTariffValue/SelectTariffValue'
import selectTariffValueClasses from '../PaymentPeriodCheckbox/index.module.css'

type StreamSelectTariffValueFieldProps = {
  value?: number | null
  onChange?: (value: number) => void
  tariff: ICourseTariff
}

/**
 * FormItem-адаптер: SelectTariffValue (чекбоксы/слайдер по настройкам тарифа)
 * вместо помесячного слайдера 1–24.
 */
const StreamSelectTariffValueField: FC<StreamSelectTariffValueFieldProps> = ({
  value,
  onChange,
  tariff,
}) => {
  const resolvedValue =
    value != null && Number(value) >= 1
      ? Math.trunc(Number(value))
      : getTariffValueMin(tariff) || 1

  return (
    <div className={selectTariffValueClasses.selectTariffValueWrapper}>
      <SelectTariffValue
        value={resolvedValue}
        setValue={(next) => onChange?.(next)}
        tariff={{
          ...tariff,
          has_demo: false,
        }}
        demo={false}
        onChangeDemo={() => {}}
      />
    </div>
  )
}

export default StreamSelectTariffValueField
